import { useCallback, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import Radio from '@/components/form/Radio';
import { updateUser } from '@/store/profile/thunks';
import { showError, showSuccess } from '@/utils';
import { DEFAULT_DATE_FORMAT, DEFAULT_HOUR_FORMAT } from '@/utils/constants';

import SectionForm from '../SectionForm';

function DateTime({ title, description }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const user = useSelector(state => state.profile.user);

	const dateOptions = [
		{ value: DEFAULT_DATE_FORMAT, label: 'DD-MM-YYYY' },
		{ value: 'mm-dd-yyyy', label: 'MM-DD-YYYY' }
	];

	const hourOptions = [
		{ value: DEFAULT_HOUR_FORMAT, label: '24' },
		{ value: '12', label: '12' }
	];

	const schema = Yup.object({
		dateFormat: Yup.string().required(),
		hourFormat: Yup.string().required()
	});

	const methods = useForm({
		resolver: yupResolver(schema),
		mode: 'onChange',
		defaultValues: {
			dateFormat: user.dateFormat || dateOptions[0].value,
			hourFormat: user.hourFormat || hourOptions[0].value
		}
	});

	const onSubmit = useCallback(async function (values) {
		setLoading(true);
		dispatch(
			updateUser({
				hourFormat: values.hourFormat,
				dateFormat: values.dateFormat
			})
		)
			.unwrap()
			.then(() => {
				setLoading(false);
				showSuccess(t('account.toast'));
			})
			.catch(error => {
				showError(error);
				setLoading(false);
			});
	}, []);

	return (
		<SectionForm
			title={title}
			description={description}
			methods={methods}
			onSubmit={onSubmit}
			loading={loading}
		>
			<div className="m-0 flex w-full flex-col items-center">
				<div className="flex flex-col gap-x-5 gap-y-4 self-start lg:flex-row lg:gap-y-6">
					<Radio
						name="dateFormat"
						label={t('account.form.dateFormat')}
						options={dateOptions}
					/>

					<Radio
						name="hourFormat"
						label={t('account.form.hourFormat')}
						options={hourOptions}
					/>
				</div>
			</div>
		</SectionForm>
	);
}

export default DateTime;
